import React from 'react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import HeroSection from '../components/home/HeroSection';
import ExecutiveSummarySection from '../components/home/ExecutiveSummarySection';
import DataMaturitySection from '../components/home/DataMaturitySection';
import DigitalMaturitySection from '../components/home/DigitalMaturitySection';
import AIMaturitySection from '../components/home/AIMaturitySection';
import SustainabilitySection from '../components/home/SustainabilitySection';
import BPCMSection from '../components/home/BPCMSection';
import SolutionsSection from '../components/home/SolutionsSection';
import OfferingsSection from '../components/home/OfferingsSection';
import AISection from '../components/home/AISection';
import TestimonialsSection from '../components/home/TestimonialsSection';
import BlogSection from '../components/home/BlogSection';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <ExecutiveSummarySection />
        <DataMaturitySection />
        <DigitalMaturitySection />
        <AIMaturitySection />
        <SustainabilitySection />
        <BPCMSection />
        <SolutionsSection />
        <OfferingsSection />
        <AISection />
        <BlogSection />
        <TestimonialsSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
